import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';

// TESTING FOR THEMES FROM EXAMPLE BY SWIPE ONE
// import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
// import { BrowserTab } from '@ionic-native/browser-tab/ngx';
// import { ServiceWorkerModule } from '@angular/service-worker';

// THINGS I ADDED MANUALLY
import { IonicStorageModule } from '@ionic/storage'; // Storage, 
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
//FIREBASE-YO: import { Firebase } from '@ionic-native/firebase/ngx';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { HTTP } from '@ionic-native/http/ngx';  // needed to avoid CORS issue with native app appearing as localhost
import { Badge } from '@ionic-native/badge/ngx';

// SEE LIST OF PROVIDERS BELOW
//    https://ionicframework.com/docs/native/
// why /ngx?
//    https://forum.ionicframework.com/t/cannot-build-ionic-4-app-with-any-native-plugins-error-ts2304-cannot-find-name-filetransfer/154197/5
import { Device } from '@ionic-native/device/ngx';
import { Network } from '@ionic-native/network/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';

// no ngx needed after I ran   "npm install --save @ionic-native/camera@4"
// ref: https://forum.ionicframework.com/t/camera-ionic-3-framework/154704/3
// tried again with:   npm install --save @ionic-native/camera@latest
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';  // npm install --save @ionic-native/camera@4



// -------------------------------------------------------------------
// MY PIPES AND COMPONENTS
// -------------------------------------------------------------------

import { PipesModule } from './pipes/pipes.module';
//import { CapitalizePipe } from './pipes/capitalize/capitalize.pipe';
//import { FiltercallbackPipe } from './pipes/filter/filtercallback.pipe';

import { ComponentsModule } from './components/components.module';
import { FootcardComponent } from './components/footcard/footcard.component';  // TEST
import { MyapiinfoComponent } from './components/myapiinfo/myapiinfo.component';
// import { MygeofenceComponent } from './components/mygeofence/mygeofence.component';
import { MycameraComponent } from './components/mycamera/mycamera.component';   // see NOTE**
import { MyeventsiteComponent } from './components/myeventsite/myeventsite.component';
import { MyquestionnaireComponent } from './components/myquestionnaire/myquestionnaire.component';
import { MyfooterComponent } from './components/myfooter/myfooter.component';   // see NOTE**
import { MygeoinfoComponent } from './components/mygeoinfo/mygeoinfo.component';
import { MyloadingComponent } from './components/myloading/myloading.component';   // see NOTE**
// // import { MymenubadgeComponent } from './components/mymenubadge/mymenubadge.component';   // see NOTE**
import { MysortheaderComponent } from './components/mysortheader/mysortheader.component';   // see NOTE**
import { MystatusComponent } from './components/mystatus/mystatus.component';   // see NOTE**

// modal pages
import { AttentionSurveyModalPage } from './pages/attention-survey-modal/attention-survey-modal.page';  
import { AttentionActionableModalPage } from './pages/attention-actionable-modal/attention-actionable-modal.page';  

// import { ServicesModule } from './services/services.module';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


// -------------------------------------------------------------------
// TRANSLATIONS
// -------------------------------------------------------------------
// https://phraseapp.com/blog/posts/localizing-ionic-applications-with-ngx-translate/
//import { TranslateService } from '@ngx-translate/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { HttpClientModule, HttpClient } from '@angular/common/http'; ALREADY ADDED ABOVE
export function createTranslateLoader(http: HttpClient) 
{
  console.log("app.module.createTranslateLoader: LANGUAGE");

  // NOTE:  this is for BASIC BOOTSTRAP of the application (e.g. when logging on)
  // It uses the local JSON language files that are within the folders
  //     ./assets/i18n/en.json
  //     ./assets/i18n/ru.json
  // etc.
  // This language data will be replaced once a valid call to the API is made to retrieve it
  return new TranslateHttpLoader(http, './assets/i18n/', '.json'); // <<<< THIS WORKS!!!
}



// -------------------------------------------------------------------

@NgModule({
  declarations: [
    // Declarations are only for components, pipes and directives
    AppComponent,
    AttentionSurveyModalPage,  // need to declare here because it can be MODAL too
    AttentionActionableModalPage,  // need to declare here because it can be MODAL too
    //CapitalizePipe,
    //FiltercallbackPipe,
    /*
    MyapiinfoComponent, // NOTE**:  individual component listed here (versus using module approach)
    MycameraComponent, // NOTE**:  individual component listed here (versus using module approach)
    MyeventsiteComponent, // NOTE**:  individual component listed here (versus using module approach)
    myquestionnaire, // NOTE**
    MyfooterComponent, // NOTE**:  individual component listed here (versus using module approach)
    MygeoinfoComponent, // NOTE**:  individual component listed here (versus using module approach)
    MyloadingComponent, // NOTE**:  individual component listed here (versus using module approach)
    MymenubadgeComponent, // NOTE**:  individual component listed here (versus using module approach)
    MysortheaderComponent, // NOTE**:  individual component listed here (versus using module approach)
    MystatusComponent, // NOTE**:  individual component listed here (versus using module approach)
    */
  ],
  entryComponents: 
  [ FootcardComponent
  , MyapiinfoComponent 
  // , MygeofenceComponent
  , MycameraComponent 
  , MyeventsiteComponent
  , MyquestionnaireComponent
  , MyfooterComponent 
  , MygeoinfoComponent 
  , MyloadingComponent 
  //, MymenubadgeComponent 
  , MysortheaderComponent 
  , MystatusComponent  
  , AttentionSurveyModalPage   // need to declare here because it can be MODAL too
  , AttentionActionableModalPage   // need to declare here because it can be MODAL too
  //, CapitalizePipe
  //, FiltercallbackPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,  // https://ionicacademy.com/http-calls-ionic/  https://www.techiediaries.com/ionic-http/
    //HTTPModule, // PETER
    //IonicModule.forRoot(),
    // https://stackoverflow.com/questions/46705791/how-can-ionic-be-setup-to-render-in-the-ios-style-by-default
    //IonicModule.forRoot(MyApp,{
    //  mode: 'ios'
    //}),
    // https://ionicframework.com/docs/theming/platform-styles
    IonicModule.forRoot({
      //rippleEffect: true,
      mode: 'ios'
    }), 
    IonicStorageModule.forRoot(), // npm install @ionic/storage --save
    // npm install @ngx-translate/core @ngx-translate/http-loader --save

    /* The forRoot static method is a convention that provides and configures services at the
       same time. Make sure you only call this method in the root module of your application, 
       most of the time called AppModule. This method allows you to configure the TranslateModule
       by specifying a loader, a parser and/or a missing translations handler.
    */
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    MomentModule,     // npm install --save angular2-moment
    FormsModule,      // added manually...  ref: https://forum.ionicframework.com/t/ionic-4-ngmodel-on-input/141909
    ComponentsModule,
    PipesModule,
    //ServicesModule,
    AppRoutingModule
    //, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [ 
    HTTP,  // PETER  ref: https://stackoverflow.com/questions/53544573/use-ionic-native-http-in-ionic-4-application
    StatusBar,
    SplashScreen,
    Device,
    Geolocation,
    Network,
    Device,
    Camera,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    // {provide: ErrorHandler, useClass: IonicErrorHandler},

    //FIREBASE-YO: Firebase,  // suggested in https://medium.com/@senning/push-notifications-with-ionic-and-cordova-plugin-firebase-ab0c0cad3cc0
    Push,
    Badge,
    // added for theme test
    // InAppBrowser,
    // BrowserTab,
    Deeplinks
  ],
  bootstrap: [AppComponent],
  exports: [
    AttentionSurveyModalPage  // modal
  , AttentionActionableModalPage  // modal
  , TranslateModule
  ]
})
export class AppModule {}
